export const QuotationCurrency = [
  { value: "KRW", name: "Korean Won" },
  { value: "USD", name: "US Dollar" },
  { value: "EUR", name: "Euro" },
  { value: "CNY", name: "Yuan" },
  { value: "JPY", name: "Yen" },
  { value: "ZAR", name: "Rand" },
]
